// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file dashboard_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DashboardAvailability } from "./dashboard_pb";
import { file_dashboard } from "./dashboard_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dashboard_service.proto.
 */
export const file_dashboard_service: GenFile = /*@__PURE__*/
  fileDesc("ChdkYXNoYm9hcmRfc2VydmljZS5wcm90bxILZ3JwYy5hcGkudjEiLAocRGFzaGJvYXJkQXZhaWxhYmlsaXR5UmVxdWVzdBIMCgRkYXRlGAEgASgFIlkKHURhc2hib2FyZEF2YWlsYWJpbGl0eVJlc3BvbnNlEjgKDGF2YWlsYWJpbGl0eRgBIAEoCzIiLmdycGMuYXBpLnYxLkRhc2hib2FyZEF2YWlsYWJpbGl0eTJ8ChBEYXNoYm9hcmRTZXJ2aWNlEmgKD2dldEF2YWlsYWJpbGl0eRIpLmdycGMuYXBpLnYxLkRhc2hib2FyZEF2YWlsYWJpbGl0eVJlcXVlc3QaKi5ncnBjLmFwaS52MS5EYXNoYm9hcmRBdmFpbGFiaWxpdHlSZXNwb25zZUIGWgQuO3BiYgZwcm90bzM", [file_dashboard]);

/**
 * @generated from message grpc.api.v1.DashboardAvailabilityRequest
 */
export type DashboardAvailabilityRequest = Message<"grpc.api.v1.DashboardAvailabilityRequest"> & {
  /**
   * @generated from field: int32 date = 1;
   */
  date: number;
};

/**
 * Describes the message grpc.api.v1.DashboardAvailabilityRequest.
 * Use `create(DashboardAvailabilityRequestSchema)` to create a new message.
 */
export const DashboardAvailabilityRequestSchema: GenMessage<DashboardAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 0);

/**
 * @generated from message grpc.api.v1.DashboardAvailabilityResponse
 */
export type DashboardAvailabilityResponse = Message<"grpc.api.v1.DashboardAvailabilityResponse"> & {
  /**
   * @generated from field: grpc.api.v1.DashboardAvailability availability = 1;
   */
  availability?: DashboardAvailability | undefined;
};

/**
 * Describes the message grpc.api.v1.DashboardAvailabilityResponse.
 * Use `create(DashboardAvailabilityResponseSchema)` to create a new message.
 */
export const DashboardAvailabilityResponseSchema: GenMessage<DashboardAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 1);

/**
 * @generated from service grpc.api.v1.DashboardService
 */
export const DashboardService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.DashboardService.getAvailability
   */
  getAvailability: {
    methodKind: "unary";
    input: typeof DashboardAvailabilityRequestSchema;
    output: typeof DashboardAvailabilityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dashboard_service, 0);

